// The page's native-media hand-off switch (BL-2683, ADR 070 — Ingest Protocol § 7.6), in the gateways layer so the
// device adapters (the staging sweep's native ask, BL-2952) and the change queue read one definition.
// Dark by default: `NEXT_PUBLIC_NATIVE_MEDIA_HANDOFF` is set nowhere until the operator has tried the hand-off on a
// phone, and this switch is then deleted in a one-line change.

/** @returns whether the page may hand queued photos to the native queue. Off unless the build sets the variable to `true`. */
export function isNativeMediaHandoffEnabled(): boolean {
  return process.env.NEXT_PUBLIC_NATIVE_MEDIA_HANDOFF === 'true';
}
